import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';
import { AsyncPageRender } from '../../../Components/AsyncComponent';
import { ProtectedRoute } from '../../../Components/Layout/ProtectedRoute';

export const routes$ = {
    salesLedger: AsyncPageRender(() => pageModule(import('./Finances/SalesLedger'))),
    PayoutListing: AsyncPageRender(() => pageModule(import('./Finances/Payouts/List'))),
    PayoutView: AsyncPageRender(() => pageModule(import('./Finances/Payouts/View'))),
};

function Router() {
    return (
        <>
            <Route
                name={'Finances.SalesLedger'}
                exact
                path={'/finances/sales-ledger/'}
                component={ProtectedRoute(routes$.salesLedger)}
            />
            <Route
                name={'Finances.Payouts'}
                exact
                path={'/finances/payouts/'}
                component={ProtectedRoute(routes$.PayoutListing)}
            />
            <Route
                name={'Finances.PayoutDetails'}
                exact
                path={'/finances/payout/:id'}
                component={ProtectedRoute(routes$.PayoutView)}
            />
        </>
    );
}

export default Router;
